import templateNameGenerators from './nameGenerators';

export default function ({ path, pageType }) {
    const templateNameGenerator = templateNameGenerators[pageType];
    if (templateNameGenerator) {
        return templateNameGenerator({ path });
    }
}
